<svg width="36" height="40" viewBox="0 0 36 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M34.105 16.77 5.818.513C3.52-.807 0 .474 0 3.74v32.506c0 2.93 3.27 4.695 5.818 3.226l28.287-16.249a3.694 3.694 0 0 0 0-6.453z" id="nkx1qlllza"/>
    </defs>
    <g transform="translate(0 .002)" fill="none" fill-rule="evenodd">
        <mask id="h03op97wzb" fill="#fff">
            <use xlink:href="#nkx1qlllza"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#nkx1qlllza"/>
        <g mask="url(#h03op97wzb)" fill="currentColor">
            <path d="M0-.002h36v40H0z"/>
        </g>
    </g>
</svg>
